import dynamic from "next/dynamic";
const Header = dynamic(() => import("../../Components/Header/Header"));

const Layout = ({children}) => {

    return (
        <>
            <Header/>
                {children}
          
        </>
    )
}
export default Layout;